import { BaseRouteService } from 'core/services';

class CarrierRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'carriers/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}

	authorizeStamps() {
		return super.create(this.base + 'authorizeStamps');
	}

	authorizationResultStamps() {
		return super.create(this.base + 'authorizationResultStamps');
	}

	authorizeUps() {
		return super.create(this.base + 'authorizeUps');
	}

	authorizationResultUps() {
		return super.create(this.base + 'authorizationResultUps');
	}
}

export default CarrierRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/CarrierRouteService.js